import styled from 'styled-components';
import { defaultTheme } from '../core/theme';

export const H1 = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  color: ${defaultTheme.colors.black};
`;
